import React, {useContext, useEffect, useState} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {UserContext} from '../../../context/User'
import AddNewFilter from '../AddNewFilter'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  let userOptions = ['All', 'Active', 'Inactive']
  const [filteredUsers, setFilteredUsers] = useState([])
  const [addFilter, setAddFilter] = useState([])
  const {getAllUsers, users} = useContext(ReservationConfigurationContext)

  const user = useContext(UserContext)

  useEffect(() => {
    getAllUsers()
  }, [getAllUsers])

  useEffect(() => {
    if (data?.template_filters_attributes?.length) {
      setAddFilter(data.template_filters_attributes)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (users.users.length && data.limit_by_status !== 'Inactive') {
      let tUsers = []
      users.users.map(u => {
        if (u.id === user.details.id) {
          tUsers.unshift({
            id: u.id,
            name: `<<me>>`,
          })
        } else {
          tUsers.push({
            id: u.id,
            name: `${u.first_name} ${u.last_name}`,
          })
        }
        return true
      })
      setFilteredUsers([...tUsers])
    } else {
      let tUsers = []
      users.users.map(u => {
        if (u.id !== user.details.id) {
          tUsers.push({
            id: u.id,
            name: `${u.first_name} ${u.last_name}`,
          })
        }
        return true
      })
      setFilteredUsers([...tUsers])
    }
  }, [users, data.limit_by_status, user])

  const handleAdd = () => {
    const values = [...addFilter]
    values.push({value: null})
    setAddFilter(values)
  }

  const handleRemoveInput = (i, val = null) => {
    const values = [...addFilter]
    if (val.id) {
      values.splice(i, 1)
      onChange('remove', 'template_filters_attributes', '', '', i, val)
    } else {
      values.splice(i, 1)
      onChange('remove', 'template_filters_attributes', '', '', i)
    }
    setAddFilter(values)
  }

  return (
    <>
      <FormControl
        variant="outlined"
        className="ap-form-control ap-textfield"
        style={{width: 200, marginTop: 16}}
      >
        <InputLabel id="">Limit by User Status</InputLabel>
        <Select
          labelId=""
          id=""
          value={data?.limit_by_status}
          label="Limit by User Status"
          onChange={(e, value) => onChange(e, 'limit_by_status')}
          style={{width: '200px'}}
        >
          {userOptions.map(opt => {
            return <MenuItem value={opt}>{`${opt}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
      <FormControl
        variant="outlined"
        className="ap-form-control ap-textfield"
        style={{width: 200, marginTop: 16}}
      >
        <InputLabel id="">Limit List to</InputLabel>
        <Select
          labelId=""
          id=""
          value={data?.limit_user_list || []}
          label="Limit List to"
          onChange={(e, value) => onChange(e, 'limit_user_list')}
          style={{width: '200px'}}
          multiple
        >
          {filteredUsers?.map(opt => {
            return <MenuItem value={opt.id}>{`${opt.name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
      <label style={{margin: '5px'}}>Filter by</label>
      <AddNewFilter
        addFilter={addFilter}
        handleRemoveInput={handleRemoveInput}
        onChange={onChange}
        data={data}
      />
      <div>
        <button
          type="button"
          style={{
            border: 'none',
            backgroundColor: 'transparent',
            color: '#336699',
            outline: 'none',
          }}
          onClick={() => handleAdd()}
        >
          Add new Filter
        </button>
      </div>
    </>
  )
}

export default FTextField
